function validate(from, to) {
    const errors = {}

    const fromGreaterThanToMessage = "Make sure that the 'to' date filter is the same or later than the 'from' date filter.";

    Object.assign(errors, from ? {} : { from: "'Filter from' must be in the format DD/MM/YYYY."});
    Object.assign(errors, to ? {} : { to: "'Filter to' must be in the format DD/MM/YYYY." });
    Object.assign(errors, !(from && to) || from <= to ? {} : { from: fromGreaterThanToMessage, to: fromGreaterThanToMessage });

    return { valid: Object.keys(errors).length === 0, errors }
}

export { validate };
